<ph-link-button icon="arrow-square-out" [routerLink]="section.route">{{ section.label }}</ph-link-button>
